import {
  DataType,
  fetchFaxIdCorrespondingData,
  getSearchedTemplatesinManualCommunicationApi,
  hideLoader,
  SEND_MANUAL_COMMUNICATION_CONSTANT,
  SendManualCommunicationProps,
  showLoader,
  WORKFLOW_UI_IDENTIFIER,
} from '@app-store'
import { DropdownType, PaginatedControlledDropDown } from '@ui-kit'
import { useEffect, useState } from 'react'
import { useAppDispatch } from '../../utils/agent.store'
import { isEmpty } from 'lodash'
import { COMM_TEMPLATE, TASK_TYPE_CONSTANTS } from '../../utils/constants'
import { useFormContext } from 'react-hook-form'

interface TemplateDropdownProps {
  handleTemplateOptionChange: (e: DropdownType<string>) => void
}

const TemplateNameDropdown = ({
  handleTemplateOptionChange,
  ...rest
}: TemplateDropdownProps) => {
  const props = rest as SendManualCommunicationProps
  const workFlowUiIdentifier = props?.task?.identifier?.ui_identifier
  const {
    formState: { errors },
    control,
    setValue,
  } = useFormContext()
  const [allTemplates, setAllTemplates] = useState<DropdownType<string>[]>([])
  const [virtualScrollForTemplate, setVirtualScrollForTemplate] =
    useState<boolean>(true)

  const [currentPageTemplateName, setCurrentPageTemplateName] =
    useState<number>(0)
  const [sizeTemplateName, setSizeTemplateName] = useState<number>(20)

  const dispatch = useAppDispatch()

  const getTemplateType = () => {
    if (workFlowUiIdentifier === WORKFLOW_UI_IDENTIFIER.FAX_OUTBOUND_TASK) {
      return 'FAX'
    } else if (
      workFlowUiIdentifier === WORKFLOW_UI_IDENTIFIER.MANUAL_TEXT_OUTBOUND
    ) {
      return 'SMS'
    } else if (
      workFlowUiIdentifier === WORKFLOW_UI_IDENTIFIER.SYSTEM_MAIL_OUTBOUND ||
      workFlowUiIdentifier === WORKFLOW_UI_IDENTIFIER.MANUAL_MAIL_OUTBOUND ||
      props?.task?.task_template?.name === TASK_TYPE_CONSTANTS.MAIL_OUTBOUND
    ) {
      return 'LETTER'
    }
    return 'FAX' //setting default as FAX
  }

  const fetchAllTemplates = async (
    page: number,
    limit: number,
    value?: string,
    operator?: string
  ) => {
    try {
      dispatch(showLoader())
      const templateType = getTemplateType()
      const filterPayload = [
        {
          search_key: SEND_MANUAL_COMMUNICATION_CONSTANT.PRODUCT_ID,
          operator: SEND_MANUAL_COMMUNICATION_CONSTANT.EQUALS,
          search_value: [parseInt(props?.productId)],
        },
        {
          search_key: SEND_MANUAL_COMMUNICATION_CONSTANT.PROGRAM_ID,
          operator: SEND_MANUAL_COMMUNICATION_CONSTANT.EQUALS,
          search_value: [parseInt(props?.programId)],
        },
        {
          search_key: SEND_MANUAL_COMMUNICATION_CONSTANT.SERVICE_ID,
          operator: SEND_MANUAL_COMMUNICATION_CONSTANT.EQUALS,
          search_value: [parseInt(props?.serviceId)],
        },
        {
          search_key: SEND_MANUAL_COMMUNICATION_CONSTANT.IS_ACTIVE,
          operator: SEND_MANUAL_COMMUNICATION_CONSTANT.EQUALS,
          search_value: [SEND_MANUAL_COMMUNICATION_CONSTANT.TRUE],
        },
        {
          search_key: SEND_MANUAL_COMMUNICATION_CONSTANT.TEMPLATE_NAME,
          operator: operator ?? SEND_MANUAL_COMMUNICATION_CONSTANT.CONTAINS,
          search_value: [value ?? ''],
        },
        {
          search_key: SEND_MANUAL_COMMUNICATION_CONSTANT.CORRESPONDENCE_TYPE,
          operator: 'IN',
          search_value: [templateType],
        },
      ]
      if (workFlowUiIdentifier === WORKFLOW_UI_IDENTIFIER.FAX_OUTBOUND_TASK) {
        filterPayload?.push({
          search_key: SEND_MANUAL_COMMUNICATION_CONSTANT.TEMPLATE_NAME,
          operator: SEND_MANUAL_COMMUNICATION_CONSTANT.CONTAINS,
          search_value: ['coversheet'],
        })
      }
      // if (
      //   workFlowUiIdentifier === WORKFLOW_UI_IDENTIFIER.MANUAL_TEXT_OUTBOUND
      // ) {
      //   filterPayload?.push({
      //     search_key: SEND_MANUAL_COMMUNICATION_CONSTANT.TEMPLATE_NAME,
      //     operator: SEND_MANUAL_COMMUNICATION_CONSTANT.CONTAINS,
      //     search_value: ['coversheet'],
      //   })
      // }
      const response = await getSearchedTemplatesinManualCommunicationApi(
        page,
        limit,
        filterPayload
      )
      const dataResponse = response.data.content
      console.log('My Data response', dataResponse)
      if (!isEmpty(dataResponse)) {
        setVirtualScrollForTemplate(true)
        const array = dataResponse.map((item: DataType) => ({
          value: item?.id,
          label: item?.template_name,
          mode_of_communication: item?.correspondence_type,
          include_editable_text: item?.include_editable_text,
          program_services: item?.program_services,
        }))
        console.log('....Array....', array)
        setAllTemplates((prevOptions) => {
          return [...(page === 0 ? [] : prevOptions ?? []), ...array]
        })
        setCurrentPageTemplateName(page)
        setSizeTemplateName(limit)
        return dataResponse
      } else {
        setVirtualScrollForTemplate(false)
      }
    } catch (error) {
      setVirtualScrollForTemplate(false)
      console.error(error)
    } finally {
      dispatch(hideLoader())
    }
  }

  const fetchStatus = async () => {
    try {
      const responseStatus = await fetchFaxIdCorrespondingData(
        Number(props?.task?.resource_id)
      )
      if (!props?.task?.resource_id) return
      setValue('template_name', responseStatus?.data?.template_id) //TODO:DEFINE TYPE
      if (
        props?.task?.identifier?.ui_identifier !==
          WORKFLOW_UI_IDENTIFIER.SYSTEM_MAIL_OUTBOUND &&
        props?.task?.identifier?.ui_identifier !==
          WORKFLOW_UI_IDENTIFIER.MANUAL_MAIL_OUTBOUND
      ) {
        setValue('to', responseStatus?.data?.fax_recipientTo?.[0])
      } else {
        setValue('to', responseStatus?.data?.recipients_to?.[0])
      }
    } catch (err) {
      console.error(err)
    }
  }

  const getDropdownLabel = () => {
    if (workFlowUiIdentifier === WORKFLOW_UI_IDENTIFIER.MANUAL_TEXT_OUTBOUND) {
      return COMM_TEMPLATE.SMS_TEMPLATE
    }
    if (workFlowUiIdentifier === WORKFLOW_UI_IDENTIFIER.FAX_OUTBOUND_TASK) {
      return COMM_TEMPLATE.COVERSHEET
    }
    return COMM_TEMPLATE.TEMPLATE_NAME
  }

  useEffect(() => {
    if (props?.task?.resource_id) {
      fetchStatus()
    }
  }, [props?.task])
  console.log('the props', props)

  useEffect(() => {
    if (props?.productId)
      fetchAllTemplates(currentPageTemplateName, sizeTemplateName, '')
  }, [props?.productId])

  console.log('My options', allTemplates)
  return (
    <PaginatedControlledDropDown
      name={`template_name`}
      label={getDropdownLabel()}
      errors={errors}
      control={control}
      onChange={handleTemplateOptionChange}
      options={allTemplates}
      required={true}
      disabled={props.isDisabled}
      dataQaId={'template_name'}
      page={currentPageTemplateName}
      limit={sizeTemplateName}
      fetchOptions={fetchAllTemplates}
      virtualScroll={virtualScrollForTemplate}
      tabIndex={props?.tabIndexOffset}
    />
  )
}
export default TemplateNameDropdown
